
export const ga_dev = {
  "key": "GTM-5ZT2PNTT",
  gtmConfig: {
    gtmResourcePath: null,
    gtmKey: "GTM-5ZT2PNTT",
    queryParams: {
      gtm_auth: null,
      gtm_preview: null,
    }
  }
  // "key": "G-6PB7GRFVYM"

}

export const ga_prod = {
  // "key": "G-6PB7GRFVYM"
  key: "GTM-PZ6B63G",
  gtmConfig: {
    gtmResourcePath: null,
    gtmKey: "GTM-PZ6B63G",
    queryParams: {
      gtm_auth: null,
      gtm_preview: null,
    }
  }
}
